import { Routes, Route } from "react-router-dom";
import UsersList from "./UsersList";

export default function CountriesPage() {
    return (
        <Routes>
            <Route path="/" element={<UsersList />}/>
        </Routes>
    )
}